import "./styles/progressbar.css";
import "./styles/scroll.css";
import "./styles/shadow.css";
import AppRouter from "./router/AppRouter";
import { SnackbarProvider } from "notistack";

function App() {
  return (
    <SnackbarProvider
      autoHideDuration={5000}
      maxSnack={3}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
    >
      <AppRouter />
    </SnackbarProvider>
  );
}

export default App;
